const initialState = {
    qrData: {},
};

const qrReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_QR_DATA':
            return {
                ...state,
                qrData: action.payload,
            };
        case 'CLEAR_QR_DATA':
            return {
                ...state,
                qrData: {},
            };
        default:
            return state;
    }
};

export default qrReducer;
